module.exports = __webpack_public_path__ + "img/0f0cad2.jpg";